import React, { useState, useEffect, useRef } from 'react';
import { Menu, X } from 'lucide-react';
import { useLanguage } from '../LanguageContext';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [showNav, setShowNav] = useState(true);
  const lastScrollY = useRef(0);
  const { lang, setLang, t } = useLanguage();

  useEffect(() => {
    const handleScroll = () => {
      const currentY = window.scrollY;
      setScrolled(currentY > 50);

      if (currentY < 50) {
        setShowNav(true);
      } else if (currentY > lastScrollY.current) {
        setShowNav(false);
      } else if (currentY < lastScrollY.current) {
        setShowNav(true);
      }

      lastScrollY.current = currentY;
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const closeMenu = () => setMobileOpen(false);
  const toggleLanguage = () => setLang(lang === 'sr' ? 'en' : 'sr');

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''} ${showNav || mobileOpen ? '' : 'hidden'} ${mobileOpen ? 'mobile-visible' : ''}`}>
      <a className="logo" href="#home" onClick={closeMenu}>
        <img src="/images/logo.png" alt="Unidea Travel logo" />
      </a>
      <ul className={`nav-links ${mobileOpen ? 'open' : ''}`}>
        <li><a href="#home" onClick={closeMenu}>{t.nav.home}</a></li>
        <li><a href="#about" onClick={closeMenu}>{t.nav.about}</a></li>
        <li><a href="#tickets" onClick={closeMenu}>{t.nav.tickets}</a></li>
        <li><a href="#business" onClick={closeMenu}>{t.nav.business}</a></li>
        <li><a href="#offers" onClick={closeMenu}>{t.nav.offers}</a></li>
        <li><a href="#inspiration" onClick={closeMenu}>{t.nav.inspiration}</a></li>
        <li><a href="#contact" onClick={closeMenu}>{t.nav.contact}</a></li>
      </ul>
      <button className="nav-lang-toggle" type="button" onClick={toggleLanguage} aria-label={t.nav.switchLabel}>
        {lang === 'sr' ? 'RS' : 'EN'}
      </button>
      <button className="mobile-menu" type="button" onClick={() => setMobileOpen(!mobileOpen)} aria-label="Toggle navigation">
        {mobileOpen ? <X size={24} /> : <Menu size={24} />}
      </button>
    </nav>
  );
};

export default Navbar;